import { render, staticRenderFns } from "./InputRating.vue?vue&type=template&id=c0cbe3a6&scoped=true"
import script from "./InputRating.vue?vue&type=script&lang=ts"
export * from "./InputRating.vue?vue&type=script&lang=ts"
import style0 from "./InputRating.vue?vue&type=style&index=0&id=c0cbe3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cbe3a6",
  null
  
)

export default component.exports